/**
 * Builds a view for interacting with setting a product content license to active or inactive.
 *
 * Usage:
 *
 *   data-sw-content-license-modal=<spin string>
 *
 */

var $ = require('js/sw-jquery/sw-jquery');

module.exports = function($fragment) {

  $fragment.swFindWithSelf('[data-sw-content-license-modal]').each(function() {
    var $el = $(this);

    require(['js/lib/views/ContentLicenseModalView', 'js/lib/models/ModelManager'], function(ContentLicenseModalView, ModelManager) {
      var spin = $el.data('swContentLicenseModal');

      new ContentLicenseModalView({
        model:  ModelManager.getProductEdit(spin),
        el:     $el
      });
    });
  });
};
